import React, {Component, Fragment} from 'react';
import {action, observable, runInAction} from 'mobx';
import {inject, observer} from 'mobx-react';
import './styles.scss';
import Draggable from "react-draggable"
import IconButton from "@material-ui/core/IconButton";
import SvgIcon from "@material-ui/core/SvgIcon";
import CamIcon from "../../assets/images/video-chat-cam";
import MicIcon from '../../assets/images/video-chat-mic';
import MutedCamIcon from "../../assets/images/video-chat-cam-muted";
import MutedMicIcon from '../../assets/images/video-chat-mic-muted';
import {ReactComponent as ScreenShare} from '../../assets/images/video/screen-share.svg';
import VideoDrag from '../../assets/images/video-chat-drag';
import VideoExtend from '../../assets/images/video/extend';
import BaseButton from "../../components/button/BaseButton";
import {FormattedMessage, injectIntl} from "react-intl";
import VideoAskToJoin from "./VideoAskToJoin";
import {DialogTypes, RemoteVideoState} from "../../constants/enums";
import DeviceSelect from "./DeviceSelect";
import UserInitials from "../../components/userInitials/UserInitials";
import VideoDecline from "./VideoDecline";
import VideoEnded from "./VideoEnded";
import VideoLoading from "./VideoLoading";
import VideoStreaming from "./VideoStreaming";
import VideoPleaseWait from "./VideoPleaseWait";
import VideoSomethingWentWrong from "./VideoSomethingWentWrong";
import {isMobile} from "../../utils/screenUtility";
import cameraIcon from "../../assets/images/camera-flip-white";
import {isStudent, isTeacher} from "../../utils/userUtility";
import MdSpeaker from "react-icons/lib/md/volume-up";
import MdMute from "react-icons/lib/md/volume-off";
import {withDialogs} from "../../components/dialog/withDialogs";
import {AskToJoinStudentDialog} from "./AskToJoinStudentDialog";
import {AskToJoinTeacherDialog} from "./AskToJoinTeacherDialog";
import {DeclineStudentDialog} from "./DeclineStudentDialog";
import mainStore from "../main/store";
import {StudentDeclinedDialog} from "./StudentDeclinedDialog";
import VideoNetworkStatus from "./VideoNetworkStatus";

export const AskToJoinStudentDialogId = 'AskToJoinStudent';
export const AskToJoinTeacherDialogId = 'AskToJoinTeacher';
export const DeclineStudentDialogId = 'DeclineStudent';
export const StudentDeclinedDialogId = 'StudentDeclined';

@inject('dialogStore', 'videoChatStore', 'chatStore', 'mainStore')
@withDialogs([AskToJoinStudentDialogId, AskToJoinTeacherDialogId, DeclineStudentDialogId, StudentDeclinedDialogId])
@injectIntl
@observer
class VideoChat extends Component {
    @observable showButtons = true;

    localVideo = null;
    remoteVideo = null;
    remoteAudio = null;
    remoteScreenAudio = null;

    componentDidMount() {
        const {openDialog, closeDialog, isOpen, videoChatStore} = this.props;
        videoChatStore.setDialogActions({
            closeDialog: closeDialog,
            openDialog: openDialog,
            isDialogOpen: isOpen
        })

        window.onbeforeunload = () => {
            if (!this.showVideoChat()) {
                return true;
            }
            return null;
        }
        if (isMobile()) {
            this.hideButtons();
        }
    }

    hideButtons = () => {
        clearInterval(this.buttonsTimeout);
        this.buttonsTimeout = setTimeout(() => {
            runInAction(() => {
                this.showButtons = false;
            })
        }, 3000)
    }

    componentWillUnmount() {
        window.onbeforeunload = undefined;
    }

    handleClose = async () => {
        const {videoChatStore} = this.props;
        videoChatStore.decline();
    }

    handleDeclineDismiss = async () => {
    }

    sendMessage = async () => {
        const {videoChatStore, chatStore, mainStore} = this.props;
        if (videoChatStore.lastDeclinedUser?.id) {
            chatStore.setActiveChat(videoChatStore.lastDeclinedUser?.id)
            mainStore.openMainAppDrawer()
        }

    }

    handleAccept = async () => {
        const {dialogStore} = this.props;
        dialogStore.openDialog(DialogTypes.StartVideoChat);
    }

    @action clickFullScreen = () => {
        if (isMobile()) {
            this.showButtons = true;
            this.hideButtons();
        }
    }

    @action localVideoRef = (ref) => {
        const {videoChatStore} = this.props;
        this.localVideo = ref;
        videoChatStore.setLocalVideoRef(ref);
    }

    @action remoteVideoRef = (ref) => {
        const {videoChatStore} = this.props;
        this.remoteVideo = ref;
        videoChatStore.setRemoteVideoRef(ref);
    }

    @action remoteAudioRef = (ref) => {
        const {videoChatStore} = this.props;
        this.remoteAudio = ref;
        videoChatStore.setRemoteAudioRef(ref);
    }

    @action remoteScreenAudioRef = (ref) => {
        const {videoChatStore} = this.props;
        this.remoteScreenAudio = ref;
        videoChatStore.setRemoteScreenAudioRef(ref);
    }

    @action remoteScreenShare = (ref) => {
        const {videoChatStore} = this.props;
        this.remoteVideo = ref;
        videoChatStore.setRemoteVideoScreenShareRef(ref);
    }

    @action fullScreenVideoRef = (ref) => {
        const {videoChatStore} = this.props;
        // this.remoteVideo = ref;
        videoChatStore.setFullScreenVideoRef(ref);
    }

    @action onClickEnd = () => {
        const {videoChatStore} = this.props;
        videoChatStore.closeVideoChat();

        setTimeout(() => {
            videoChatStore.setFullScreen(false);
        });
    }

    @action onClickRemote = () => {
        const {videoChatStore} = this.props;
        videoChatStore.setFullScreen(!videoChatStore.fullScreen);
    }

    @action onStop = (event) => {
        const {videoChatStore} = this.props;
        if (!videoChatStore.fullScreen) {
            this.defaultX = event.screenX;
            this.defaultY = event.screenY;
        }
    }

    @action onClickMute = () => {
        const {videoChatStore} = this.props;
        videoChatStore.toggleMuteAudio();
    }

    @action onClickVideoMute = () => {
        const {videoChatStore} = this.props;
        videoChatStore.toggleMuteVideo();
    }

    @action onClickShare = () => {
        const {videoChatStore} = this.props;
        videoChatStore.toggleScreenShare();
    }

    @action onAccept = () => {
        const {dialogStore, videoChatStore} = this.props;
        if (videoChatStore.videoChatStarted) {
            videoChatStore.approveStudent();
        } else {
            dialogStore.openDialog(DialogTypes.StartVideoChat);
            videoChatStore.approveStudentPending();
        }

    }

    @action onDecline = () => {
        const {videoChatStore} = this.props;
        videoChatStore.decline();
    }

    @action onCloseDecline = () => {
        const {videoChatStore} = this.props;
        videoChatStore.closeVideoChat();
    }

    @action onCloseSomethingWentWrong = () => {
        const {videoChatStore} = this.props;
        videoChatStore.closeVideoChat(true);
    }

    renderRemoteView = () => {
        const {videoChatStore, videoChatStarted} = this.props;
        switch (videoChatStore.remoteVideoState) {
            case RemoteVideoState.Init:
                return <VideoPleaseWait isRoomOpen={videoChatStore.videoChatStarted} peerUser={videoChatStore.peerUser} onClose={this.onCloseDecline}/>;
            case RemoteVideoState.Request:
                return <VideoAskToJoin onAccept={this.onAccept} onDecline={this.onDecline} student={videoChatStore.peerUser} full={!videoChatStarted}/>;
            case RemoteVideoState.Declined:
                return <VideoDecline peerUser={videoChatStore.peerUser} onClose={this.onCloseDecline}/>
            case RemoteVideoState.Approved:
            case RemoteVideoState.ApprovedPending:
            case RemoteVideoState.Loading:
                return <VideoLoading/>
            case RemoteVideoState.PeerEnd:
                return <VideoEnded peerUser={videoChatStore.peerUser} onClose={this.onCloseDecline}/>
            case RemoteVideoState.VideoStreamStarted:
                return <VideoStreaming onClickRemote={this.onClickRemote}/>
            case RemoteVideoState.SomethingWentWrong:
                return <VideoSomethingWentWrong onClose={this.onCloseSomethingWentWrong}/>
            default:
                break;

        }
    }

    renderBottomPanel = () => {
        const {videoChatStore} = this.props;
        const {remoteVideoState, videoChatStarted} = videoChatStore;
        let render;
        switch (remoteVideoState) {
            case RemoteVideoState.Init:
            case RemoteVideoState.Request:
            case RemoteVideoState.Declined:
            case RemoteVideoState.PeerEnd:
            case RemoteVideoState.Loading:
            case RemoteVideoState.SomethingWentWrong:
                render = false;
                break;
            default:
                render = true;
        }
        if (!isMobile() && (render || videoChatStarted)) {
            return <div className="video-buttons">
                <SvgIcon classes={{root: 'drag-icon'}} viewBox="0 0 12 28">{VideoDrag}</SvgIcon>
                <SvgIcon classes={{root: 'extend-icon'}} onClick={this.onClickRemote}
                         viewBox="0 0 17 16">{VideoExtend}</SvgIcon>
            </div>
        }
        return null;
    }

    renderTopPanel = () => {
        const {videoChatStore} = this.props;
        const {toggleMuteSpeaker, switchVideoDevice, toggleMinimizeMode, speakerMuted} = videoChatStore;
        return <div className="video-top-buttons">
            <IconButton classes={{root: 'top-button left'}} onClick={toggleMinimizeMode}>
                <SvgIcon classes={{root: 'extend-icon'}} onClick={this.onClickRemote}
                         viewBox="0 0 17 16">{VideoExtend}</SvgIcon>
            </IconButton>

            <IconButton classes={{root: 'top-button'}} onClick={toggleMuteSpeaker}>
                {speakerMuted ? <MdMute className="lighter-gray" style={{fontSize: 20}}/> : <MdSpeaker style={{fontSize: 20}}/>}
            </IconButton>

            <IconButton classes={{root: 'top-button'}} onClick={switchVideoDevice}>
                <SvgIcon viewBox="0 0 24 24">{cameraIcon}</SvgIcon>
            </IconButton>
        </div>
    }


    renderMinimizeMode = () => {
        const {videoChatStore} = this.props;
        const {remoteVideoState, videoChatTime} = videoChatStore;
        let innerComponent;
        switch (remoteVideoState) {
            case RemoteVideoState.Init:
                if (isTeacher()) {
                    innerComponent = <FormattedMessage id={'video.chat.minimize.empty.teacher'}/>;
                } else if (isStudent()) {
                    innerComponent = <FormattedMessage id={'video.chat.minimize.empty.student'}/>;
                }
                break;
            case RemoteVideoState.Request:
                innerComponent = <FormattedMessage id={'video.chat.minimize.student.request'}/>;
                break;
            case RemoteVideoState.Declined:
                innerComponent = <FormattedMessage id={'video.chat.minimize.teacher.decline'}/>;
                break;
            case RemoteVideoState.PeerEnd:
                innerComponent = <FormattedMessage id={'video.chat.minimize.hangup'}/>;
                break;
            case RemoteVideoState.Loading:
            case RemoteVideoState.ApprovedPending:
            case RemoteVideoState.Approved:
                innerComponent = <FormattedMessage id={'video.chat.minimize.loading'}/>;
                break;
            case RemoteVideoState.SomethingWentWrong:
                innerComponent = <FormattedMessage id={'video.chat.minimize.something.went.wrong'}/>;
                break;
            case RemoteVideoState.VideoStreamStarted:
                innerComponent =
                    <div className={'video-chat-ongoing'}><FormattedMessage id={'video.chat.minimize.ongoing'}/> &#8226;
                        <span className={"video-chat-timer"}>{videoChatTime}</span>
                    </div>
                break;

            default:
                innerComponent = <FormattedMessage id={'video.chat.minimize'}/>
        }
        return <>
            <div className='video-chat-wrapper-minimize' onClick={videoChatStore.toggleMinimizeMode}>
                {innerComponent}
            </div>
            <VideoNetworkStatus/>
        </>

    }

    showVideoChat = () => {
        const {videoChatStore, dialogStore, isOpen} = this.props;
        const {videoChatStarted, remoteVideoState, minimizeMode} = videoChatStore;
        return (!videoChatStarted && remoteVideoState !== RemoteVideoState.PeerEnd) ||
            dialogStore.getDialogState(DialogTypes.StartVideoChat) ||
            minimizeMode ||
            isOpen(AskToJoinStudentDialogId) ||
            isOpen(AskToJoinTeacherDialogId);
    }


    render() {
        const {videoChatStore, isOpen, closeDialog, intl: {formatMessage: translate}} = this.props;
        const {
            videoChatStarted, hasScreenShare, audioMuted, videoMuted, screenShared, remoteAudioMuted, remoteVideoMuted, peerUser, remoteVideoState,
            minimizeMode, speakerMuted, noFlipLocalVideo, screenShareSupport, remoteMirroringActive, localMirroringActive, showNetworkWarning,
        } = videoChatStore;

        const videoStreamStarted = remoteVideoState === RemoteVideoState.VideoStreamStarted;
        const hide = this.showVideoChat()

        let fullScreen = videoChatStore.fullScreen;
        if (isMobile()) {
            if (videoChatStarted) {
                fullScreen = true;
            }
        }

        return (
            <Fragment>
                {minimizeMode && this.renderMinimizeMode()}
                <div
                    className={`video-chat-wrapper ${fullScreen ? 'full' : ''} ${hide ? 'hide' : ''} ${noFlipLocalVideo ? 'no-flip' : ''} ${screenShared ? 'screen-share' : ''} ${this.showButtons ? 'show-buttons' : ''}`}
                    onClick={this.clickFullScreen}
                >
                    {fullScreen && <div className={'video-chat-full-inner'}>
                        {isMobile() && this.renderTopPanel()}
                        {isMobile() && <div className={"video-container upper-mobile"}>
                            <div className={"remote-wrapper"}>
                                {this.renderRemoteView()}
                            </div>
                        </div>}
                        {remoteVideoMuted && <div className="remove-video-full-initials" data-testid="remove-video-full-initials">
                            <UserInitials fullName={videoChatStore.peerUser?.name}/>
                        </div>}
                        <video ref={this.fullScreenVideoRef} className={`remote-video-full ${remoteMirroringActive ? 'mirror' : ''}`} autoPlay playsInline
                               muted={true}/>
                        <VideoNetworkStatus/>
                        <div className={"full-screen-remote-buttons"}>
                            {remoteAudioMuted && <IconButton classes={{root: `device-selector-btn muted`}} data-testid={"remote-button-mute"}>
                                <SvgIcon classes={{root: 'device-selector-icon'}}
                                         viewBox="0 0 24 24">{MutedMicIcon}</SvgIcon>
                            </IconButton>}
                        </div>
                        <div className={`buttons-full ${!videoChatStarted ? 'hide' : ''}`}>
                            <div className={"video-chat-device-selection"}>
                                <DeviceSelect icon={MicIcon} iconMuted={MutedMicIcon} muted={videoChatStore.audioMuted}
                                              onClickMute={this.onClickMute} titleKey='video.chat.select.audio'
                                              deviceList={videoChatStore.audioDevices} onDeviceSet={videoChatStore.setAudioDevice} compact={isMobile()}/>
                                <DeviceSelect icon={CamIcon} iconMuted={MutedCamIcon} muted={videoChatStore.videoMuted}
                                              onClickMute={this.onClickVideoMute} titleKey='video.chat.select.video'
                                              deviceList={videoChatStore.videoDevices} onDeviceSet={videoChatStore.setVideoDevice} compact={isMobile()}
                                              withMirror={true} toggleLocalMirroring={videoChatStore.toggleLocalMirroring}
                                              localMirroringActive={videoChatStore.localMirroringActive}
                                />
                                {screenShareSupport &&
                                <IconButton classes={{root: `device-selector-btn ${screenShared ? 'shared' : ''}`}} onClick={this.onClickShare}>
                                    <ScreenShare/>
                                </IconButton>}
                                <BaseButton classes={{root: `local-end`}} onClick={this.onClickEnd}
                                            label={<FormattedMessage id={isMobile() ? 'video.chat.end.short' : 'video.chat.end.full'}/>}/>
                            </div>
                        </div>
                    </div>}
                    <Draggable cancel=".react-resizable-handle" allowAnyClick={false} onStop={this.onStop} handle={'.drag-icon'}>
                        <div className="video-chat-inner">
                            <div className="video-container upper">
                                <div className="remote-wrapper">
                                    {!isMobile() && this.renderRemoteView()}
                                    <audio ref={this.remoteAudioRef} autoPlay muted={speakerMuted}/>
                                    <audio ref={this.remoteScreenAudioRef} autoPlay />
                                    {fullScreen && hasScreenShare && <div className={`remote remote-video ${!videoStreamStarted ? 'hide' : ''}`}>
                                        <video ref={this.remoteVideoRef} className={`remote-view ${remoteMirroringActive ? 'mirror' : ''}`} autoPlay
                                               playsInline/>
                                    </div>}
                                    {!fullScreen &&
                                    <div className={`remote remote-video ${!videoStreamStarted ? 'hide' : ''}`}>
                                        {videoChatStore.peerUser && <div className="remote-initials">
                                            <UserInitials fullName={videoChatStore.peerUser.name}/>
                                        </div>}
                                        <video ref={this.remoteVideoRef}
                                               className={`remote-view ${remoteVideoMuted ? 'hide' : ''} ${remoteMirroringActive ? 'mirror' : ''}`} autoPlay
                                               playsInline
                                               muted={true}/>
                                        <div className="buttons">
                                            {remoteAudioMuted && <IconButton classes={{root: `device-selector-btn muted`}} onClick={this.onClickMute}>
                                                <SvgIcon classes={{root: 'device-selector-icon'}}
                                                         viewBox="0 0 24 24">{remoteAudioMuted ? MutedMicIcon : MicIcon}</SvgIcon>
                                            </IconButton>}
                                            {hasScreenShare &&
                                            <IconButton classes={{root: `device-selector-btn shared`}}>
                                                <ScreenShare/>
                                            </IconButton>}
                                        </div>
                                    </div>}
                                </div>
                            </div>
                            <div className="video-container lower">
                                <div className={`local-video ${!videoChatStarted ? 'hide' : ''}`}>
                                    <video ref={this.localVideoRef} className={`local-view ${localMirroringActive ? 'mirror' : ''}`} autoPlay playsInline
                                           muted/>
                                    {!fullScreen && <VideoNetworkStatus/>}
                                    {!fullScreen && <div className={`buttons`}>
                                        <IconButton classes={{root: `device-selector-btn ${audioMuted ? 'muted' : ''}`}} onClick={this.onClickMute}>
                                            <SvgIcon classes={{root: 'device-selector-icon'}}
                                                     viewBox="0 0 24 24">{audioMuted ? MutedMicIcon : MicIcon}</SvgIcon>
                                        </IconButton>
                                        <IconButton classes={{root: `device-selector-btn ${videoMuted ? 'muted' : ''}`}} onClick={this.onClickVideoMute}>
                                            <SvgIcon classes={{root: 'device-selector-icon'}}
                                                     viewBox="0 0 24 24">{videoMuted ? MutedCamIcon : CamIcon}</SvgIcon>
                                        </IconButton>
                                        {screenShareSupport &&
                                        <IconButton classes={{root: `device-selector-btn ${screenShared ? 'shared' : ''}`}} onClick={this.onClickShare}>
                                            <ScreenShare/>
                                        </IconButton>}
                                        <BaseButton classes={{root: `local-end`}} onClick={this.onClickEnd}
                                                    label={<FormattedMessage id={'video.chat.end.short'}/>}/>

                                    </div>}
                                </div>
                            </div>
                            {this.renderBottomPanel()}
                        </div>
                    </Draggable>
                </div>
                {isStudent() && <AskToJoinStudentDialog isOpen={isOpen} closeDialog={closeDialog} handleClose={this.handleClose} handleCancel={this.handleClose}
                                                        handleAccept={this.handleAccept}/>}
                {!isStudent() && <>
                    <AskToJoinTeacherDialog isOpen={isOpen} closeDialog={closeDialog} handleClose={this.handleClose} handleCancel={this.handleClose}
                                            handleAccept={this.handleAccept}/>
                    <DeclineStudentDialog isOpen={isOpen} closeDialog={closeDialog} handleCancel={this.sendMessage} handleAccept={this.handleDeclineDismiss}/>
                    <StudentDeclinedDialog isOpen={isOpen} closeDialog={closeDialog} handleCancel={this.handleClose} handleAccept={this.handleDeclineDismiss}/>
                </>}
            </Fragment>
        );

    }
}

export default VideoChat;
